export default "__VITE_ASSET__BnRZvL1a__"